import { gtmEventType } from '@Components/Utilities/SandhillsConstants';
import { gtmPushEvent } from '@Components/Utilities/SandhillsUtility';
import TranslationText from '@Components/Utilities/TranslationText';
import ActionButton from '@Components/Shared/ActionButton';
import translator from '@Components/Utilities/Translator';

const PhoneButton = (props) => {

    const className = props.className || '';

    if (props.IsWhatsApp) {
        return (
            <ActionButton
                phoneType={props.PhoneType}
                url={props.WhatsAppLink}
                className={'button whatsapp des-whatsapp ts-button ' + className}
                iconClass='fab fa-whatsapp gtm-noclick'
                target='_blank'
                buttonClass='gtm-noclick'
                buttonText={<TranslationText tKey='sandhills.whatsapp' />}
                ariaLabel={translator.translate('sandhills.whatsapp') + " (" + translator.translate('sandhills.opensinanewtab') + ")"}
                onClick={() => gtmPushEvent(gtmEventType.whatsApp)}
            />
        );
    } else if (props.IsFBMessenger) {
        return (
            <ActionButton
                phoneType={props.PhoneType}
                url={props.FBMessengerLink}
                className={'button facebook-messenger des-fb-messenger ts-button ' + className}
                iconClass='fab fa-facebook-messenger gtm-noclick'
                target='_blank'
                buttonClass='gtm-noclick'
                buttonText={<TranslationText tKey='sandhills.fbmessenger' />}
                ariaLabel={translator.translate('sandhills.fbmessenger') + " (" + translator.translate('sandhills.opensinanewtab') + ")"}
                onClick={() => gtmPushEvent(gtmEventType.messenger)}
            />
        );
    } else {
        return (
            <ActionButton
                phoneType={props.PhoneType}
                url={'tel:' + props.UnformattedPhoneNumber}
                className={'button ts-button ' + className}
                iconClass='fas fa-phone-alt gtm-noclick'
                iconText={props.IconText || ''}
                buttonClass='gtm-noclick'
                buttonText={props.ButtonText || (props.IsForRentOnly || props.IsRY ? <TranslationText tKey='sandhills.call' /> : <TranslationText tKey='sandhills.callseller' />)}
                onClick={() => gtmPushEvent(gtmEventType.call)}
            />
        );
    }
};

export default PhoneButton;